import { MuiThemeProvider } from '@inbody/core';
import '@inbody/core/fonts.css';
import { QueryProvider } from '@inbody/data';
import { AuthProvider } from '@inbody/keycloak';

// 공용 컴포넌트가 useTranslation 을 쓰므로 렌더 전에 i18n 을 초기화해야 한다.
import './shared/i18n/setup';
import { BrowserRouter } from './shared/lib/react-router';

function App() {
  return (
    <MuiThemeProvider toastPosition="top-center">
      <QueryProvider>
        <AuthProvider
          config={{
            clientId: 'inbody-procurement-hub',
            url: 'https://keycloak.weareinbody.com',
          }}
        >
          <BrowserRouter />
        </AuthProvider>
      </QueryProvider>
    </MuiThemeProvider>
  );
}

export default App;
